import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgQuickSendSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 18.971a.747.747 0 01-.22.56l-2 2a.75.75 0 01-1.06 0l-1.566-1.566-2.488 1.659A.75.75 0 013.25 21V5A2.75 2.75 0 016 2.25h10A2.75 2.75 0 0118.75 5v4a.75.75 0 01-.75.75 2 2 0 00-1.63.848l-4.255 6.035a2 2 0 00-.366 1.153v1.185zM7.25 7A.75.75 0 018 6.25h6a.75.75 0 010 1.5H8A.75.75 0 017.25 7zm0 4a.75.75 0 01.75-.75h6a.75.75 0 010 1.5H8a.75.75 0 01-.75-.75zm0 4a.75.75 0 01.75-.75h2a.75.75 0 010 1.5H8a.75.75 0 01-.75-.75z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 11.5a.75.75 0 00-1.356-.441l-4.572 6.286a.75.75 0 00.607 1.19h2.678v3.25a.75.75 0 001.357.442l4.571-6.286a.75.75 0 00-.606-1.191H18.75V11.5zm-1.893 5.536h-1.955l2.348-3.23V15.5c0 .414.336.75.75.75h1.956l-2.349 3.23v-1.694a.75.75 0 00-.75-.75z",
    fill: "currentColor"
  })));
}

export { SvgQuickSendSolid as ReactComponent };
